import { render, staticRenderFns } from "./VInvoiceHeaderForm.vue?vue&type=template&id=0889b1a7&"
import script from "./VInvoiceHeaderForm.vue?vue&type=script&lang=js&"
export * from "./VInvoiceHeaderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports